export default __webpack_public_path__ + "static/media/clearsky.61618d35.mp4";